import {Directive, EventEmitter, Output} from '@angular/core';
import type Quill from 'quill';

@Directive({
  selector: '[aztrixQuillButton]',
})
export class AztrixQuillButtonDirective {
  @Output() quillEditorChange = new EventEmitter<Quill>();
}
